import React from 'react';
import {useState} from 'react';
// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Navbar,
  Container,
  Col,
} from 'react-bootstrap';
import {Row} from 'react-foundation';
// import DNS from '../components/DNS/dns.js';
import DNSO from '../components/DNS/dns-offline.js';
import 'assets/css/register.css';
// import axios from '../components/Axios/Axios.js';
import NotificationAlert from 'react-notification-alert';

/**
 * This function handle all the event and style in the register page.
 * @function Register
 * @return {HTML} the register's page.
 */
const Delete = () => {
  const [logError, setLogError] = useState(false);
  // const [showBuilding, setBuilding] = useState(null);
  // const [showBuilding2, setBuilding2] = useState([])
  const [showEmail, setEmail] = useState([]);
  // const [showUsername, setUsername] = useState([]);
  // const [showFname, setFname] = useState([]);
  // const [showLname, setLname] = useState([]);
  const [showPassword, setPassword] = useState([]);

  // const [showAdmin, setAdmin] = useState(false);
  // const [showAccueil, setAccueil] = useState(false);
  // const [showSupercollab, setSupercollab] = useState(false);
  // const [showCollab, setCollab] = useState(false);

  // const [showEntreprise, setEntreprise] = useState([]);
  // const [showEntrepriseSelected, setEntrepriseSelected] = useState([]);

  // const requestOptionsAxiosHeaders = {
  //   headers: {'Content-Type': 'application/json'},
  // };

  // const requestOptionsAxiosPut = {
  //   email: showEmail,
  //   username: 'pseudo',
  //   // firstName: showFname,
  //   // lastName: showLname,
  //   // password: showPassword,
  //   active: true,
  //   is_staff: true,
  //   admin: false,
  //   collab: true,
  //   superCollab: false,
  //   accueil: false,
  //   subAdmin: false,
  //   confirm: true,
  //   building_list: [],
  //   banner: false,
  // };

  const notify2 = (place, notifSentence) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{notifSentence}</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
    setTimeout(() => {
      window.location.href = DNSO + '/login';
    }, 1000);
  };

  // const requestOptionsAxiosGet = {
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
  // };

  const reqDelete = () => {
    // let tmp = [];
    // tmp = tmp.concat(showBuilding);

    // requestOptionsAxiosPut['building_list'] = tmp;
    // requestOptionsAxiosPut['entreprise'] = parseInt(showEntrepriseSelected);
    // if (showAdmin == true) {
    //   requestOptionsAxiosPut['admin'] = showAdmin;
    //   requestOptionsAxiosPut['accueil'] = false;
    //   requestOptionsAxiosPut['superCollab'] = false;
    //   requestOptionsAxiosPut['collab'] = false;
    // }
    // if (showAccueil == true) {
    //   requestOptionsAxiosPut['admin'] = false;
    //   requestOptionsAxiosPut['accueil'] = showAccueil;
    //   requestOptionsAxiosPut['superCollab'] = false;
    //   requestOptionsAxiosPut['collab'] = false;
    // }
    // if (showSupercollab == true) {
    //   requestOptionsAxiosPut['admin'] = false;
    //   requestOptionsAxiosPut['accueil'] = false;
    //   requestOptionsAxiosPut['superCollab'] = showSupercollab;
    //   requestOptionsAxiosPut['collab'] = false;
    // }
    // if (showCollab == true) {
    //   requestOptionsAxiosPut['admin'] = false;
    //   requestOptionsAxiosPut['accueil'] = false;
    //   requestOptionsAxiosPut['superCollab'] = false;
    //   requestOptionsAxiosPut['collab'] = showCollab;
    // }
    // console.log('requestOptionsAxiosPut', requestOptionsAxiosPut);
    // axios
    //     .post(
    //         DNS + '/users/createUser/',
    //         JSON.stringify(requestOptionsAxiosPut),
    //         requestOptionsAxiosHeaders,
    //     )
    //     .then((response) => {
    notify2('tc', 'Votre demande a bien été effectuée, Nous vous recontacterons par e-mail dans les plus brefs délais pour confirmer la suppression de votre compte.');
    console.log('test', showEmail, showPassword);
    // window.location.href = DNSO + '/login';
    // }).catch((err) => console.error(err));
  };

  const notificationAlertRef = React.useRef(null);
  const notify = (place) => {
    const type = 'danger';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>
              Votre adresse mail ou mot de passe est incorrect. Veuillez le
              vérifier.
            </p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-simple-remove',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
    setLogError(false);
  };

  // pour la navbar
  const collapseOpen = false;

  // const getEntreprise = () => {
  //   const url = window.location.href;
  //   const Infos = url.split('/')[4];
  //   const ParsedBuilding = Infos.split('&')[0];
  //   const Building = ParsedBuilding.split('!')[1];
  //   axios
  //       .get(
  //           DNS + '/entreprise/crudEntreprise/' + Building + '/',
  //           requestOptionsAxiosGet,
  //       )
  //       .then((response) => {
  //         let tmp = [];
  //         response.data.fields.map((elem, key) => {
  //           tmp = tmp.concat({'pk': elem.pk, 'value': elem.nameEntreprise});
  //         });
  //         setEntreprise(tmp);
  //       });
  // };

  const handleEnter = (enter) => {
    if (enter.charCode === 13) {
      enter.preventDefault();
      reqDelete();
    }
  };
  // const setInfoFromUrl = () => {
  //   const url = window.location.href;
  //   const Infos = url.split('/')[4];
  //   const Role = Infos.split('&')[1];
  //   const ParsedBuilding = Infos.split('&')[0];
  //   const toConvert = ParsedBuilding.split('!')[1];
  //   const Building = toConvert.replace(/-/g, ' ');
  //   setBuilding(parseInt(Building));
  //   if (Role == 'admin') {
  //     setAdmin(true);
  //   }
  //   if (Role == 'accueil') {
  //     setAccueil(true);
  //   }
  //   if (Role == 'VIP') {
  //     setSupercollab(true);
  //   }
  //   if (Role == 'collab') {
  //     setCollab(true);
  //   }
  // };

  // const [cardClasses, setCardClasses] = React.useState('card-hidden');
  React.useEffect(() => {
    // setInfoFromUrl();
    // getEntreprise();
    // setTimeout(function() {
    //   setCardClasses('');
    // }, 1000);
    console.log('hahaha trrash');
  }, []);

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Navbar
        className="position-absolute w-100"
        expand="lg"
        variant={collapseOpen ? 'white' : 'transparent'}
        style={{
          paddingTop: '15px',
          backgroundColor: 'initial',
          borderBottom: '1px solid transparent',
          border: '1px solid transparent',
          zIndex: '1',
        }}
      >
        <Container>
          <div className="navbar-wrapper">
            <Navbar.Brand href="#pablo" onClick={(e) => e.preventDefault()}>
              <img src={require('assets/img/logo-havea.png').default} />
            </Navbar.Brand>
          </div>
        </Container>
      </Navbar>
      <div
        className="full-page section-image"
        data-color="black"
        // data-image={require('assets/img/batiment-curve.jpg').default}
      >
        <div className="content d-flex align-items-center p-0">
          <Container>
            <Col className="mx-auto" lg="6" md="8">
              <Form className="form" method="">
                {logError == true ? notify('tc') : ''}
                <Card className={'card-delete '}>
                  <Card.Header>
                    <h3 className="header text-center text-white">
                    Demande de Suppression de Données Personnelles - Haveagooday
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <div>
                      <p style={{textAlign: 'center'}}>Chez Haveagooday, nous comprenons l'importance de votre vie privée et de la sécurité de vos données personnelles.</p>
                      <p style={{textAlign: 'center'}}> Si vous souhaitez que nous supprimions vos données personnelles associées à votre compte, veuillez suivre la procédure ci-dessous. Notre équipe technique traitera votre demande dans les plus brefs délais.</p>
                      <a>Comment soumettre votre demande ?</a>
                      <br/>
                      <p style={{textAlign: 'center'}}> Remplissez le champ ci-dessous avec l'adresse email et le mot de passe associée à votre compte dans notre application. Cliquez sur le bouton "Envoyer " pour soumettre votre demande de suppression.</p>
                      <a>Quelles données seront supprimées de nos serveurs ?</a>
                      <p style={{textAlign: 'center'}}>- Votre compte utilisateur et toutes les informations associées.</p>
                      <p style={{textAlign: 'center'}}>- Vos données personnelles, y compris, mais sans s'y limiter, votre nom, adresse email, et historique d'utilisation.</p>
                      <a>Conservation des données :</a>
                      <p style={{textAlign: 'center'}}>- Certaines données peuvent être conservées pour respecter nos obligations légales ou réglementaires, y compris, mais sans s'y limiter, les logs de transactions et les historiques de paiement. Ces données seront conservées de manière sécurisée et uniquement pour la durée requise par la loi.</p>
                      <br/>
                      <p style={{textAlign: 'center'}}>Nous nous engageons à traiter votre demande avec la plus grande attention et dans le respect total de votre vie privée.</p>
                      <br/>
                    </div>
                    <Form>
                      <Row>
                        <Col>
                          {/* EMAIL FIELD  */}
                          <Form.Group controlId="formBasicEmail">
                            <Form.Label>Adresse Email* :</Form.Label>
                            <Form.Control
                              required
                              type="email"
                              placeholder="Entrez votre email"
                              onChange={(e) => {
                                setEmail(e.currentTarget.value);
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>

                    <Form>
                      <Row>
                        <Col>
                          {/* PASSWORD FIELD  */}
                          <Form.Group controlId="formBasicPassword">
                            <Form.Label>Mot de passe* :</Form.Label>
                            <Form.Control
                              required
                              type="password"
                              placeholder="Entrez votre mot de passe"
                              onChange={(e) => {
                                setPassword(e.currentTarget.value);
                              }}
                              onKeyPress={handleEnter}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                  <Card.Footer className="ml-auto mr-auto">
                    <Button
                      className={'btn-round btn-wd'}
                      onClick={reqDelete}
                    >
                      Envoyer
                    </Button>
                    <br />
                    <a href="/login">
                      <Button className="btn-wd btn-round " variant="warning">
                        Se connecter
                      </Button>
                    </a>
                    <div className="clearfix"></div>
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
        <div
          className="full-page-background"
          style={{
            backgroundImage:
              'url(' + require('assets/img/Immeuble-client.jpg').default + ')',
          }}
        ></div>

        <footer
          className="footer position-absolute fixed-bottom"
          style={{
            position: 'relative',
            zIndex: '2',
            background: 'transparent',
            border: '1px solid transparent',
          }}
        >
          <div className="container">
            <nav>
              <p className="text-center m-0" style={{color: 'white'}}>
                © {(new Date().getFullYear())}{' '}
                <a href="http://haveagooday.com/">
                  Have<span style={{color: 'yellow'}}>a</span>gooday
                </a>
                , made with love by IMPERIATEC©
              </p>
            </nav>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Delete;
